import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatNumber'
})
export class FormatNumberPipe implements PipeTransform {

 
  transform(value: any, ...args: any[]): any {
      if(!value || (typeof value !== 'string' && typeof value !== 'number')) return value;
      const splittedCost = value.toString().split('.');
      return Number(value ?? 0) > 999 ? splittedCost[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : value;
  }

}
